document.addEventListener("cartStepReady", function () {
    function checkCart() {
        fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
                let giftSelector = document.getElementById("giftSelectorSection");
                let greetingMessageSection = document.getElementById("greetingMessageSection");
                let calendarSection = document.getElementById("calendarSection");

                let currentStep = cart.attributes?.current_step ? parseInt(cart.attributes.current_step) : 0;

                if (giftSelector) giftSelector.style.display = (currentStep === 1) ? "block" : "none";
                if (greetingMessageSection) greetingMessageSection.style.display = (currentStep === 0) ? "block" : "none";
                if (calendarSection) calendarSection.style.display = (currentStep === 2) ? "block" : "none";

                sessionStorage.setItem("currentStep", currentStep.toString());
            })
            .catch(error => console.error("Error fetching cart:", error));
    }

    function storeStepBeforeCartChange() {
        let activeStep = document.querySelector(".progress-bar .step.active");
        if (activeStep) {
            sessionStorage.setItem("currentStep", activeStep.textContent.trim().toLowerCase());
        }
    }

    document.body.addEventListener("click", function (event) {
        if (event.target.classList.contains("add-to-cart") || event.target.classList.contains("cart-remove")) {
            storeStepBeforeCartChange();
            setTimeout(checkCart, 500);
        }
    });

    document.addEventListener("progressBarUpdated", function () {
        storeStepBeforeCartChange();
        checkCart();
    });

    function activateFirstCollection(sectionId) {
        let section = document.getElementById(sectionId);
        if (!section) return;

        let firstTab = section.querySelector(".collection-tab");
        let firstContent = section.querySelector(".collection-content");

        if (firstTab && firstContent) {
            section.querySelectorAll(".collection-tab").forEach(t => t.classList.remove("active"));
            section.querySelectorAll(".collection-content").forEach(c => c.classList.remove("active"));

            firstTab.classList.add("active");
            firstContent.classList.add("active");
        }
    }

    function setupCollectionTabs() {
        document.querySelectorAll(".collection-tab").forEach(tab => {
            tab.addEventListener("click", function () {
                let collectionName = this.getAttribute("data-collection");
                let section = this.closest("#giftSelectorSection");

                if (!section) return;

                section.querySelectorAll(".collection-tab").forEach(t => t.classList.remove("active"));
                section.querySelectorAll(".collection-content").forEach(c => c.classList.remove("active"));

                this.classList.add("active");
                section.querySelector(`.collection-content[data-collection="${collectionName}"]`).classList.add("active");
            });
        });
    }

    document.addEventListener("progressBarUpdated", function () {
        let activeStep = document.querySelector(".progress-bar .step.active");
        if (activeStep && activeStep.textContent.trim() === "Gift") {
            activateFirstCollection("giftSelectorSection");
            setupCollectionTabs();
            setupAddToCart();
        }
    });

    function setupAddToCart() {
        document.querySelectorAll(".add-to-cart").forEach(button => {
            button.addEventListener("click", function (event) {
                event.preventDefault();
                let productId = this.getAttribute("data-product-id");

                storeStepBeforeCartChange();

                this.innerText = "...";
                this.disabled = true;

                fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ id: productId, quantity: 1 })
                })
                    .then(response => response.json())
                    .then(data => {
                        updateCartUI(data);
                        this.innerText = "Hinzugefügt!";
                        setTimeout(() => { this.innerText = "In den Warenkorb"; this.disabled = false; }, 1000);
                    })
                    .catch(error => {
                        console.error("Error:", error);
                        this.innerText = "Error!";
                        setTimeout(() => { this.innerText = "In den Warenkorb"; this.disabled = false; }, 2000);
                    });
            });
        });
    }

    function updateCartUI(cartData) {
        fetch('/cart')
            .then(response => response.text())
            .then(html => {
                let parser = new DOMParser();
                let doc = parser.parseFromString(html, 'text/html');
                let newCartItems = doc.querySelector("#main-cart-items");

                if (newCartItems) {
                    document.querySelector("#main-cart-items").innerHTML = newCartItems.innerHTML;
                }
            });
    }

    // ✅ Startup actions NOW inside the ready event
    checkCart();
    activateFirstCollection("giftSelectorSection");
    setupCollectionTabs();
    setupAddToCart();
});
